module.exports = __webpack_public_path__ + "img/加盟优势.33f2a757.png";